<template>
  <v-container>
    <v-row dense>
      <v-col cols="12" xs="12" sm="12">
        <highcharts :options="chartOptions"></highcharts>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
/* eslint-disable no-debugger */
import { Chart } from "highcharts-vue";
import { mapState, mapActions } from "vuex";

export default {
  name: "chartVentas",
  data() {
    return {
      valores: [],
      meses: [],
      totales: [],
    };
  },
  beforeMount() {
    this.graficar();
  },
  components: {
    highcharts: Chart,
  },
  props: {
    title: String,
    modo: String,
    array: Array,
  },
  watch: {
    array: function(val) {
      this.graficar();
      console.log(val);
    },
  },
  methods: {
    graficar() {
      let arr = this.array;
      let me = this;
      let mesn = "";
      arr.forEach(function(x) {
        switch (parseInt(x._id.mes)) {
          case 1:
            mesn = "Enero";
            break;
          case 2:
            mesn = "Febrero";
            break;
          case 3:
            mesn = "Marzo";
            break;
          case 4:
            mesn = "Abril";
            break;
          case 5:
            mesn = "Mayo";
            break;
          case 6:
            mesn = "Junio";
            break;
          case 7:
            mesn = "Julio";
            break;
          case 8:
            mesn = "Agosto";
            break;
          case 9:
            mesn = "Setiembre";
            break;
          case 10:
            mesn = "Octubre";
            break;
          case 11:
            mesn = "Noviembre";
            break;
          case 12:
            mesn = "Diciembre";
            break;
          default:
            mesn = "error";
        }

        me.meses.push(mesn + " de " + x._id.year);
        // let total = new Number(x.total)
        // total = total.toPrecision(6)
        me.totales.push(x.total);
      });
    },
  },
  computed: {
    ...mapState("usuarioNamespace", ["token"]),
    chartOptions() {
      let me = this;
      return {
        chart: { type: this.modo },
        title: { text: this.title },
        xAxis: {
          categories: this.meses,
          crosshair: true,
        },
        yAxis: {
          min: 0,
          title: {
            text: "Totales",
          },
        },
        tooltip: {
          headerFormat:
            '<span style="font-size:10px">{point.key}</span><table>',
          pointFormat:
            '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
            '<td style="padding:0"><b>{point.y:.1f}</b></td></tr>',
          footerFormat: "</table>",
          shared: true,
          useHTML: true,
        },
        plotOptions: {
          column: {
            pointPadding: 0.2,
            borderWidth: 0,
          },
        },
        series: [
          {
            name: "Total",
            data: this.totales,
          },
          // {
          //   name: "2021",
          //   data: this.totales,
          // },
          // {
          //   name: "2022",
          //   data: this.totales,
          // },
        ],
      };
    },
  },
};
/* eslint-disable no-debugger */
</script>
